import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { name: '恋爱韩漫', path: '/category/love' },
      { name: '动作韩漫', path: '/category/action' },
      { name: '奇幻韩漫', path: '/category/fantasy' },
      { name: '悬疑韩漫', path: '/category/suspense' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { name: '我独自升级', path: '/article/2' },
      { name: '全知读者视角', path: '/article/6' },
      { name: '剑尊归来', path: '/article/4' },
      { name: '女神降临', path: '/article/1' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '联系方式', path: '/about' },
      { name: '用户协议', path: '/about' },
      { name: '隐私政策', path: '/about' },
    ],
  },
];

const socialLinks = [
  { icon: 'ri-weibo-line', href: '#', label: '微博' },
  { icon: 'ri-wechat-line', href: '#', label: '微信' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-500">
      <div className="w-full px-4 md:px-6">
        <div className="py-14">
          <div className="bg-secondary-600/20 rounded-lg px-6 py-10">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="lg:w-1/4">
                <span className="font-heading text-2xl text-background-50">
                  韩漫网
                </span>
                <p className="mt-3 text-sm text-background-50/70 leading-relaxed">
                  韩漫网致力于为中文读者提供最全面的韩国漫画在线阅读服务，支持下拉式浏览，完全免费，随时随地畅读热门韩漫。
                </p>
              </div>

              <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-8">
                {footerLinks.map((group) => (
                  <div key={group.title}>
                    <h4 className="text-sm font-medium text-background-50 uppercase tracking-wider mb-4">
                      {group.title}
                    </h4>
                    <ul className="flex flex-col gap-2.5">
                      {group.links.map((link) => (
                        <li key={link.name}>
                          <Link
                            to={link.path}
                            className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                          >
                            {link.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-50/50">
                &copy; 2026 韩漫网 h8wx1.com.com — 保留所有权利
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-background-50/40">
                  用户协议
                </span>
                <span className="text-xs text-background-50/20">|</span>
                <span className="text-xs text-background-50/40">
                  隐私政策
                </span>
              </div>
              <div className="flex items-center gap-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    rel="nofollow"
                    className="w-9 h-9 flex items-center justify-center bg-background-50/15 hover:bg-background-50/25 rounded-full transition-colors duration-200 cursor-pointer"
                  >
                    <i className={`${social.icon} text-sm text-background-50`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}